<template>
<zj-layout-container>
  <zj-layout-main>
    <div class="zj-layout-main-content bgcolor scrollable" ref="container">
      无线设备
    </div>
  </zj-layout-main>
</zj-layout-container>
</template>

<script>
export default {
  name: 'ZjWifiHome',
  controller: 'UI',
  action: 'Home'
}
</script>
